import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function branchLoader({ params }: LoaderFunctionArgs) {
    const branchId = params.branchId;
    if (branchId) {
        const branch = await queryClient.fetchQuery({
            queryKey: ['branch', branchId],
            queryFn: async () => {
                const { data } = await api.branch.findOne(branchId);
                return data;
            },
        });
        return branch;
    }
    return null;
}
